import { baseAPIRequest } from 'utilities/http';

function sendActivationEmail (data) {

	return baseAPIRequest({ url: '/account/popups/activation-email', data, params: { method: 'POST' } });

}

export default sendActivationEmail;
